import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { firebaseApp } from './firebase'
import { VueFire, VueFireAuth } from 'vuefire'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import './assets/app.css'
import { applyTheme, getTheme } from './composables/useTheme'

async function boot() {
  await applyTheme()
  const theme = getTheme()
  setFavicon(theme.favicon)
  createApp(App)
    .use(router)
    .use(VueFire, { firebaseApp, modules: [VueFireAuth()] })
    .mount('#app')
}

const setFavicon = (url) => {
  let link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = url
  document.getElementsByTagName('head')[0].appendChild(link)
}

boot()
